import { z } from 'zod';
/** Arguments several tool groups share (spec 130 section 5.3). */
export const id = z.uuid();
export const ifMatch = z.string().min(1).max(200).describe('The etag returned by the last read or write of this object; a stale one is refused (version-conflict).');
//# sourceMappingURL=tool-base.js.map